module.exports = __webpack_public_path__ + "img/logo-horizontal.1628f3f3.png";